import React from "react";
import PDFRenderer from "./PDFRenderer";

export interface PDFPreviewItem {
  cloudfrontUrl: string;
  thumbnailUrl?: string;
  mediaId: string;
}

export interface PDFPreviewProps {
  items: PDFPreviewItem[];
  pdfPaperSize?: string;
}

function PDFPreview({ items, pdfPaperSize }: PDFPreviewProps) {
  const pdfWidth = pdfPaperSize === "Portrait" ? 816 : 1056;
  const mode = "FlyerPreview";

  return (
    <>
      {items.map((item, index) => (
        <React.Fragment key={item.mediaId || index}>
          <PDFRenderer item={item} pdfWidth={pdfWidth} mode={mode} />
        </React.Fragment>
      ))}
    </>
  );
}

export default PDFPreview;
